
import {useTranslation} from "react-i18next";
import {useEffect, useState} from 'react';
// material
import {
  Card,
  Stack,
  Container,
  Typography,
} from '@mui/material';
// components
import Page from '../../components/Page';
// mock
import LoanForm from "../../sections/@dashboard/loans/LoanForm";



// ---------------------------------------------------------------------


const override = {
  // display: "block",
  margin: "0 auto",
  // borderColor: "red",
};


export default function SaveLoan() {

  const { t, i18n } = useTranslation();
  
  
  useEffect(() => {
    i18n.changeLanguage("es")
  }, [])

  return (
    <Page title={t('loan_form')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('loan_form')}
          </Typography>
        </Stack>
        <Card style={{padding: "50px"}}>
         <LoanForm />
        </Card>
      </Container>
    </Page>
  );
}
